export class ResponsaveisTecnicosModel {
  id: number;
  nome: string;
  cargo_pt: string;
  cargo_en: string;
  cargo_es: string;
  registro: string;
}



// WEBPACK FOOTER //
// ./src/app/laudos-cd-responsaveis-tecnicos/responsaveis-tecnicos.model.ts